import {
    Button,
    Container,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Text
} from "@chakra-ui/react";
import { SupportEmail } from "../../utils/surveyStatusSchemas";


const SurveySubmissionModal =({
                                  isOpen,
                                  onClose,
                                  onSubmit,
                                  isLoading
                              }: {
    isOpen: boolean;
    onClose: () => void;
    onSubmit: () => void;
    isLoading: boolean;
}) => {
    
    return (
        <Modal  isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader as="h2">Confirm your submission</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <Container> 
                       <Text size="2rem"> Once confirmed, you'll be logged out and the form will be locked.
                           If you need to reopen your form submission, contact <Text as="span" color="blue">{SupportEmail}</Text></Text>
                    </Container>
                 
                </ModalBody>

                <ModalFooter>
                    <Button variant="outline" mr={3} onClick={onClose} isDisabled={isLoading}>
                        Make more changes
                    </Button>
                    <Button variant='solid'
                    colorScheme='blue'        
                        onClick={onSubmit}
                        isLoading={isLoading}
                        isDisabled={isLoading}>
                        Yes, submit
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
}

export default SurveySubmissionModal;